import { type ObjectValuesUnionType } from '../utils/typing';

export type SoundInstance = {
  play: () => unknown;
  stop: () => unknown;
  mute: () => unknown;
  unmute: () => unknown;
  getDuration: () => number;
  getState: () => 'unloaded' | 'loading' | 'loaded';
  on: (eventName: string, callback: () => void) => void;
  src: string;
};

export const GlobalSoundIds = Object.freeze({
  GLOBAL_FREEBETS: 'GLOBAL:FREEBETS',
});

export const KLSoundIds = Object.freeze({
  KL_MUSIC: 'KOH_LANTA:MUSIC',
  KL_FLUTES_1: 'KOH_LANTA:FLUTES_1',
  KL_FLUTES_2: 'KOH_LANTA:FLUTES_2',
  KL_FLUTES_3: 'KOH_LANTA:FLUTES_3',
  KL_FLUTES_4: 'KOH_LANTA:FLUTES_4',
  KL_FLUTES_5: 'KOH_LANTA:FLUTES_5',
  KL_FLUTES_6: 'KOH_LANTA:FLUTES_6',
  KL_INTRO: 'KOH_LANTA:INTRO',
  KL_BADGE_WON_FISHING: 'KOH_LANTA:BADGE_WON:FISHING',
  KL_BADGE_LOST_FISHING: 'KOH_LANTA:BADGE_LOST:FISHING',
  KL_BADGE_WON_FIRECAMP: 'KOH_LANTA:BADGE_WON:FIRECAMP',
  KL_BADGE_LOST_FIRECAMP: 'KOH_LANTA:BADGE_LOST:FIRECAMP',
  KL_BADGE_WON_HUT: 'KOH_LANTA:BADGE_WON:HUT',
  KL_BADGE_LOST_HUT: 'KOH_LANTA:BADGE_LOST:HUT',
  KL_BADGE_WON_RICE: 'KOH_LANTA:BADGE_WON:RICE',
  KL_BADGE_LOST_RICE: 'KOH_LANTA:BADGE_LOST:RICE',
  KL_BADGE_WON_WATER: 'KOH_LANTA:BADGE_WON:WATER',
  KL_BADGE_LOST_WATER: 'KOH_LANTA:BADGE_LOST:WATER',
  KL_BADGE_WON_BALANCE: 'KOH_LANTA:BADGE_WON:BALANCE',
  KL_BADGE_LOST_BALANCE: 'KOH_LANTA:BADGE_LOST:BALANCE',
  KL_BADGE_WON_GRAND_BLUE: 'KOH_LANTA:BADGE_WON:GRAND_BLUE',
  KL_BADGE_LOST_GRAND_BLUE: 'KOH_LANTA:BADGE_LOST:GRAND_BLUE',
  KL_BADGE_WON_DUO: 'KOH_LANTA:BADGE_WON:DUO',
  KL_BADGE_LOST_DUO: 'KOH_LANTA:BADGE_LOST:DUO',
  KL_BADGE_WON_SLOTH: 'KOH_LANTA:BADGE_WON:SLOTH',
  KL_BADGE_LOST_SLOTH: 'KOH_LANTA:BADGE_LOST:SLOTH',
  KL_BADGE_WON_BAMBOOS: 'KOH_LANTA:BADGE_WON:BAMBOOS',
  KL_BADGE_LOST_BAMBOOS: 'KOH_LANTA:BADGE_LOST:BAMBOOS',
  KL_COMFORT_WON: 'KOH_LANTA:COMFORT_WON',
  KL_COMFORT_LOST: 'KOH_LANTA:COMFORT_LOST',
  KL_COLLAR_WON: 'KOH_LANTA:COLLAR_WON',
  KL_COLLAR_LOST: 'KOH_LANTA:COLLAR_LOST',
  KL_COLLAR_USED: 'KOH-LANTA:COLLAR_USED',
  KL_ELIMINATION_T_RED: 'KOH-LANTA:ELIMINATION:T_RED',
  KL_ELIMINATION_T_WHITE: 'KOH-LANTA:ELIMINATION:T_WHITE',
  KL_TRANSITION_T_WHITE: 'KOH-LANTA:TRANSITION:T_WHITE',
  KL_TRANSITION_ORIENTATION: 'KOH-LANTA:TRANSITION:ORIENTATION',
  KL_TRANSITION_POLE: 'KOH-LANTA:TRANSITION:POLE',
  KL_MARK_WON: 'KOH_LANTA:MARK_WON',
  KL_MARK_LOST: 'KOH_LANTA:MARK_LOST',
  KL_TAG_WON: 'KOH_LANTA:TAG_WON',
  KL_TAG_LOST: 'KOH_LANTA:TAG_LOST',
  KL_KNIFE_WON: 'KOH-LANTA:KNIFE_WON',
  KL_KNIFE_LOST: 'KOH-LANTA:KNIFE_LOST',
  KL_KNIFE_MISS_1: 'KOH-LANTA:KNIFE_MISS:1',
  KL_KNIFE_MISS_2: 'KOH-LANTA:KNIFE_MISS:2',
  KL_KNIFE_MISS_3: 'KOH-LANTA:KNIFE_MISS:3',
  KL_POLE_WON: 'KOH-LANTA:POLE_WON',
  KL_POLE_WON_STAGE_1: 'KOH-LANTA:POLE_WON:STAGE_1',
  KL_POLE_WON_STAGE_2: 'KOH-LANTA:POLE_WON:STAGE_2',
  KL_POLE_WON_STAGE_3: 'KOH-LANTA:POLE_WON:STAGE_3',
  KL_POLE_WON_STAGE_4: 'KOH-LANTA:POLE_WON:STAGE_4',
  KL_POLE_WON_STAGE_5: 'KOH-LANTA:POLE_WON:STAGE_5',
  KL_POLE_LOST: 'KOH-LANTA:POLE_LOST',
  KL_POLE_FALL_STAGE_1: 'KOH-LANTA:POLE_FALL:STAGE_1',
  KL_POLE_FALL_STAGE_2: 'KOH-LANTA:POLE_FALL:STAGE_2',
  KL_POLE_FALL_STAGE_5: 'KOH-LANTA:POLE_FALL:STAGE_5',
  KL_POLE_PRICE_WON: 'KL_POLE_PRICE_WON',
  KL_TRY_AGAIN: 'KL_TRY_AGAIN',
  KL_VICTORY_1: 'KOH-LANTA:VICTORY1',
  KL_VICTORY_2: 'KOH-LANTA:VICTORY2',
  KL_VICTORY_3: 'KOH-LANTA:VICTORY3',
  KL_VICTORY_4: 'KOH-LANTA:VICTORY4',
  KL_VICTORY_5: 'KOH-LANTA:VICTORY5',
  KL_VICTORY_6: 'KOH-LANTA:VICTORY6',
  KL_VICTORY_7: 'KOH-LANTA:VICTORY7',
  KL_VICTORY_8: 'KOH-LANTA:VICTORY8',
  KL_VICTORY_9: 'KOH-LANTA:VICTORY9',
  KL_VICTORY_10: 'KOH-LANTA:VICTORY10',
  KL_VICTORY_11: 'KOH-LANTA:VICTORY11',
  KL_VOTE_1: 'KOH-LANTA:VOTE_1',
  KL_VOTE_2: 'KOH-LANTA:VOTE_2',
  KL_VOTE_3: 'KOH-LANTA:VOTE_3',
  KL_RESTART: 'KOH-LANTA:RESTART',
});

export const OverlaySoundIds = Object.freeze({
  ANTHEM_DE: 'ANTHEM:DE',
  ANTHEM_ES: 'ANTHEM:ES',
  ANTHEM_FR: 'ANTHEM:FR',
});

export const GRSoundIds = Object.freeze({
  GR_WIN_BLUE_TAG_MOVING: 'GIFT_RACE:WIN_BLUE_TAG_MOVING',
  GR_WIN_MULTIPLICATOR_WHEEL: 'GIFT_RACE:WIN_MULTIPLICATOR_WHEEL',
  GR_WIN_TOTAL_FREEBETS_AMOUNT_INCREMENT: 'GIFT_RACE:WIN_TOTAL_FREEBETS_AMOUNT_INCREMENT',
  GR_WIN_TICK: 'GIFT_RACE:WIN_TICK',
  GR_WIN_CHIP: 'GIFT_RACE:WIN_CHIP',
  GR_LOST_CHIP: 'GIFT_RACE:LOST_CHIP',
});

export const MonopolySoundIds = Object.freeze({
  MP_WIN_CARD: 'MONOPOLY:WIN_CARD',
  MP_WIN_FAMILY: 'MONOPOLY:WIN_FAMILY',
  MP_WIN_FREEBET: 'MONOPOLY:WIN_FREEBET',
});

export const BoomSoundIds = Object.freeze({
  BOOM_HALLOWEEN_BASKET: 'BOOM:HALLOWEEN_BASKET',
  BOOM_START: 'BOOM:START',
});

export const SoundIds = Object.freeze({
  ...GlobalSoundIds,
  ...KLSoundIds,
  ...OverlaySoundIds,
  ...GRSoundIds,
  ...MonopolySoundIds,
  ...BoomSoundIds,
});
export type SoundId = ObjectValuesUnionType<typeof SoundIds>;
